/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2026 Rochester Software Associates (service@rocsoft.com)
 */

import PropTypes from 'prop-types';
import { DropdownMenu as BDropdownMenu, DropdownItem } from 'reactstrap';

import useLocalizationTextFormatted from '~/components/text/useLocalizationTextFormatted';

import normalizeOption from './normalizeOption';

const DropdownMenu = ({ labelID, options, value, setValue }) => {
    const selectArialabel = useLocalizationTextFormatted('AUTHENTICATED_UI.ARIA.SELECT_DROPDOWN_OPTIONS');
    return (
        <BDropdownMenu aria-labelledby={labelID}>
            {options.map((option) => {
                const nOption = normalizeOption(option);
                let ariaLabel = nOption?.ariaLabel;

                if (!nOption.label && !ariaLabel) {
                    // No label for the option, and no aria-label
                    // This is the "SELECT" option
                    ariaLabel = selectArialabel;
                }

                return (
                    <DropdownItem
                        key={nOption?.value}
                        onClick={() => setValue(nOption.value)}
                        data-value={ariaLabel}
                        aria-label={ariaLabel}
                        active={nOption.value === value}
                    >
                        {nOption.label}
                    </DropdownItem>
                );
            })}
        </BDropdownMenu>
    );
};

DropdownMenu.propTypes = {
    labelID: PropTypes.string.isRequired,
    options: PropTypes.oneOfType([
        PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.any,
                label: PropTypes.node,
            })
        ),
        PropTypes.arrayOf(PropTypes.string),
    ]).isRequired,
    value: PropTypes.any,
    setValue: PropTypes.func,
};

export default DropdownMenu;
